module.exports = __webpack_public_path__ + "img/article5_9.ee22f1e7.jpg";